import { GLA_Container } from "./GroupLessonArea.styled";
import { AnimatePresence } from "framer-motion";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../stores";
import { GroupsLesson } from "./GroupsLesson";
import { GroupLessonView } from "./GroupLessonView";
import { useEffect, useRef } from "react";

interface GroupLessonAreaProps {}

export const GroupLessonArea = observer(({}: GroupLessonAreaProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	const wasViewOpenedRef = useRef(false);

	const isView = selected.selectedGrandChartGroupLesson.id > 0;

	useEffect(() => {
		if (isView) {
			wasViewOpenedRef.current = true;
		}
	}, [isView]);

	return (
		<GLA_Container>
			<AnimatePresence
				mode="wait"
				onExitComplete={() => {
					if (isView) return;
					selected.clearSelectedGrandChartGroupLesson();
				}}
			>
				{isView ? (
					<GroupLessonView key="group-lesson-view" />
				) : (
					<GroupsLesson
						key={`groups-lesson-list-${selected.id}-${wasViewOpenedRef.current ? "fade" : "stagger"}`}
						animationMode={wasViewOpenedRef.current ? "fade" : "stagger"}
					/>
				)}
			</AnimatePresence>
		</GLA_Container>
	);
});
